import React, { useEffect, useState } from 'react'
import { GetAllDocument } from '../../../../API/GetData';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { FilePdfOutlined } from '@ant-design/icons';

const TableDocument = ({ dataSouce }) => {

    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await GetAllDocument(dataSouce?.AccountId, dataSouce?.COACode);
                setData(res);
                console.log();

            } catch (error) {
                console.log(error);
            }
        }

        if (dataSouce) {
            fetchData();
        }

    }, [dataSouce]);


    const columns = [
        {
            key: "key",
            title: "#",
            dataIndex: "key",
            width: 80,
            sorter: (a, b) => a.key - b.key,
        },
        {
            key: 'FileName',
            title: 'File Name',
            dataIndex: 'FileName',
            editable: true,
            render: (value, record) => {
                const fileName = record.PathName?.split("_").slice(1).join("_") || value;
                return (
                    <Link
                        to={`/api/${record.PathName}`}
                        target="_blank"
                        className="text-blue-500"
                    >
                        <FilePdfOutlined style={{ marginRight: 8, color: '#ff4d4f' }} />
                        {fileName}
                    </Link>
                );
            }
        }
    ];

    return (
        <div>
            <h1 className="border-b-2 pb-1 text-xl mb-2">Document</h1>
            <Table
                bordered
                columns={columns}
                dataSource={data}
                scroll={{
                    x: 'max-content',
                }}
            />
        </div>
    )
}

export default TableDocument